import dynamic from "next/dynamic";

const QuantumLoader = dynamic(
  () => import("@/components/shared/loading/Quantum"),
  { ssr: false }
);

export default QuantumLoader;
